/**
 * Avalara © 2017
 * file: engines/opus_ui/src/AvataxSandboxCard.js
 */

import React, { Component } from 'react';
import AvataxCard from './AvataxCard';

class AvataxSandboxCard extends Component {
  render() {
    const { deliveryInfo } = this.props;

    return <AvataxCard deliveryInfo={deliveryInfo} />;
  }
}

export default AvataxSandboxCard;
